exports.f = Object.getOwnPropertySymbols;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_object-gops.js
 ** module id = 156
 ** module chunks = 0
 **/